import { render, staticRenderFns } from "./NbaFullStats.vue?vue&type=template&id=13d7c706&scoped=true"
import script from "./NbaFullStats.vue?vue&type=script&lang=js"
export * from "./NbaFullStats.vue?vue&type=script&lang=js"
import style0 from "./NbaFullStats.vue?vue&type=style&index=0&id=13d7c706&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d7c706",
  null
  
)

export default component.exports